var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Transform } from 'class-transformer';
import { transformOtelRulesToConfigRules, transformConfigRulesToOtelRules, getDisabledRulesIndexes, } from './sampling-rules.manipulator';
export class TracingSamplingConfigModel {
    accountId;
    tracingAccountId;
    disabledRules = [];
    rules = [];
    createdBy;
    createdAt;
    updatedBy;
    updatedAt;
}
__decorate([
    Transform((_, { rules }) => getDisabledRulesIndexes(rules), { toPlainOnly: true }),
    __metadata("design:type", Array)
], TracingSamplingConfigModel.prototype, "disabledRules", void 0);
__decorate([
    Transform((_, { rules }) => transformConfigRulesToOtelRules(rules), { toPlainOnly: true }),
    Transform((_, { rules, disabledRules }) => transformOtelRulesToConfigRules(rules, disabledRules), {
        toClassOnly: true,
    }),
    __metadata("design:type", Array)
], TracingSamplingConfigModel.prototype, "rules", void 0);
//# sourceMappingURL=tracing-sampling-config.js.map